import { LinearProgress, IconButton, Stack } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import React, { useState } from "react";
import ShimeringText from "components/chat-v2/ShimmeringText";

export default function AIMenuGeneration({ aiMenu }) {
  console.log("PREVIEW");

  return (
    <Stack alignItems="center">
      <div
        style={{
          position: "relative",
          // display: "inline-block",
          maxWidth: "70%",
        }}
      >
        <img
          src={aiMenu.imageUrl}
          alt=""
          style={{
            display: "block",
            maxWidth: "100%",
            borderRadius: "4px",
            filter: "brightness(70%)",
            transition: "filter 0.3s",
          }}
        />

        {/* Generating shimmer overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(120deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0.1) 100%)",
            backgroundSize: "200% 100%",
            animation: "shimmer 1.5s infinite",
            pointerEvents: "none",
          }}
        />

        {/* Linear progress for generating */}
        <LinearProgress color="secondary" />

        <style>
          {`
          @keyframes shimmer {
            0% { background-position: -200% 0; }
            100% { background-position: 200% 0; }
          }
        `}
        </style>
      </div>
      <ShimeringText>{aiMenu.info}</ShimeringText>
    </Stack>
  );
}
